// components/taskoverview/TaskOverview.js
import React from "react";
import { Link } from "react-router-dom";
import { Row, Container } from 'react-bootstrap';
import './TaskOverview.css';

const TaskOverview = (props) => {
  const { task, description, time, location, scheduledTaskId, onTaskClick } = props;

  const TaskContent = () => (
    <div className="task-overview-card">
      <div className="task-header">
        <h3 className="task-title">{task}</h3>
        <div className="task-icon">⚽</div>
      </div>
      
      <div className="task-details">
        {description && (
          <div className="task-detail-item">
            <span className="detail-icon">📝</span>
            <p className="task-description">{description}</p>
          </div>
        )}
        
        <div className="task-detail-item">
          <span className="detail-icon">🕐</span>
          <h5 className="task-time">{time}</h5>
        </div>
        
        {location && (
          <div className="task-detail-item">
            <span className="detail-icon">📍</span>
            <h5 className="task-location">{location}</h5>
          </div>
        )}
      </div>
      
      <div className="task-status-indicator"></div>
    </div>
  );

  if (onTaskClick) {
    return (
      <div 
        className="task-overview-clickable" 
        onClick={() => onTaskClick(scheduledTaskId)}
      >
        <TaskContent />
      </div>
    );
  } else {
    return (
      <Link 
        to={`/calendar/scheduledtasks/${scheduledTaskId}`} 
        className="task-overview-link"
      >
        <TaskContent />
      </Link>
    );
  }
};

export default TaskOverview;
